import { connect, useDispatch } from "react-redux";
import { VzPageContainer } from "../../../../layouts/VzPageContainer";
import { Col, Row, Container, Button, Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  getProfileSetting,
  updateProfileSetting,
  sendOtpToVerifyEmail,
  saveNewEmail,
} from "./ProfileSettingActions";
import FormikControl from "../../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { hideLoading, showLoading } from "react-redux-loading-bar";
import { uploadFile } from "../../../../utilities/ImageUpload";
import { toast } from "react-toastify";
import { getImageExtensions } from "../../../../utilities/FUNCTIONS";
import history from "../../../../history";
import axios from "../../../../apis/Api";

const ProfileSetting = (props) => {
  const [ImageURL, setImageURL] = useState(null);

  const [modalShow, setModalShow] = useState(false);
  const [isOldEmailOtpVerify, setIsOldEmailOtpVerify] = useState(false);
  const profileInitialValues = {
    id: "",
    fullName: "",
    distributor: "",
    distCenter: "",
    email: "",
    phoneNo: "",
    cnic: "",
    image: null,
  };

  const emailModalInitialValues = {
    id: "",
    oldEmail: "",
    oldEmailOtp: "",
    newEmail: "",
  };

  const [currentEntity, setCurrentEntity] = useState(profileInitialValues);
  const [emailUpdate, setEmailUpdate] = useState(emailModalInitialValues);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validationSchema = Yup.object().shape({
    fullName: Yup.string()
      .required("Full Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Full Name can only contain letters and spaces")
      .max(30),
  });

  const validationSchemaEmailModal = Yup.object().shape({
    oldEmail: Yup.string()
      .required("Old email is required")
      .email("Invalid email format"),

    oldEmailOtp: Yup.string()
      .required("Old email OTP is required")
      .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
      .matches(/^\S*$/, "Spaces are not allowed"),

    newEmail: Yup.string()
      .required("New email is required")
      .email("Invalid email format")
      .notOneOf(
        [Yup.ref("oldEmail")],
        "New email must be different from old email"
      ),
  });

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    if (!currentEntity) {
      toast.error("User data not loaded.");
      return;
    }

    if (!currentEntity?.fullName || currentEntity?.fullName.length == 0) {
      toast.error("Full Name Is Required");
      return;
    }

    const request = {
      id: currentEntity?.id || "",
      fullName: currentEntity?.fullName || "",
      image: ImageURL,
    };

    await props.updateProfileSetting(request);

    setIsSubmitting(false);
  };

  const handleBackBtn = async (data) => {
    history.push("/dashboard");
    history.go("/dashboard");
  };

  useEffect(() => {
    props.getProfileSetting();
  }, []);

  useEffect(() => {
    if (props.Profile?.user) {
      setCurrentEntity(props.Profile.user);
      setImageURL(props.Profile.user?.image ?? null);
    }
  }, [props.Profile]);

  const dispatch = useDispatch();
  const saveImage = async (event) => {
    dispatch(showLoading());
    const extension = getImageExtensions();
    if (event.target.files.length > 0) {
      let currentExtension = event.target.files[0].name
        .split(".")
        .pop()
        .toLowerCase();
      if (!extension.includes(currentExtension)) {
        dispatch(hideLoading());
        toast.error("Selected invalid file extension");
        return;
      }
      uploadFile(event.target.files[0])
        .then(async (response) => {
          dispatch(hideLoading());
          setImageURL(response);
        })
        .catch(function (error) {
          dispatch(hideLoading());
          toast.error(error);
        });
    } else {
      dispatch(hideLoading());
    }
  };
  const removeImage = () => {
    setImageURL(null);
  };

  const ShowEmailModal = () => {
    setEmailUpdate({
      ...emailUpdate,
      id: currentEntity.id,
      oldEmail: currentEntity.email,
    });

    setModalShow(true);
  };

  const handleSendOtp = async (data) => {
    setIsSubmitting(true);

    let request = {
      email: emailUpdate.oldEmail,
    };

    setIsOldEmailOtpVerify(false);

    await props.sendOtpToVerifyEmail(request);

    setIsSubmitting(false);
  };

  const handleVerifyOtp = async (data) => {
    let request = {
      email: emailUpdate.oldEmail,
      oneTimePassword: emailUpdate.oldEmailOtp,
      tokenProvider: "Email",
    };

    dispatch(showLoading());

    setIsSubmitting(true);

    await axios
      .post(`api/Authenticate/VerifyOtpToUserThroughEmail`, request)
      .then((res) => {
        if (res.data.response.isSuccess) {
          toast.success(res.data.message);
          setIsOldEmailOtpVerify(true);
        } else {
          toast.info(res.data.message);
          setIsOldEmailOtpVerify(false);
        }
        setIsSubmitting(false);
        dispatch(hideLoading());
      })
      .catch(function (error) {
        console.log(error);
        dispatch(hideLoading());
      });
  };

  const [isHovered, setIsHovered] = useState(false);

  const hoverStyle = {
    color: isHovered ? "#f4af96" : "inherit",
    cursor: isHovered ? "grab" : "pointer",
    textDecorationLine: "underline",
    float: "right",
    marginBottom: "5px",
  };

  const handleSubmitChangeEmailModal = async (e) => {
    dispatch(showLoading());
    if (!isOldEmailOtpVerify) {
      toast.info("Old Email Is Not Verified");
      return;
    }

    if (emailUpdate.newEmail.length == 0) {
      toast.info("New Email Is Required");
      return;
    }

    const request = {
      id: currentEntity?.id || "",
      email: emailUpdate.newEmail || "",
    };

    setIsSubmitting(true);

    await axios
      .post(`api/Authenticate/SaveNewEmail`, request)
      .then((res) => {
        debugger;
        if (res.data.response.isSuccess) {
          toast.success(res.data.message);
        } else {
          toast.info(res.data.message);
        }
        dispatch(hideLoading());
        setIsSubmitting(false);
        setModalShow(false);
      })
      .catch(function (error) {
        console.log(error);
        dispatch(hideLoading());
      });

    // props.saveNewEmail(request);
  };

  const handleCloseChangeEmailModal = () => {
    setModalShow(false);
    setIsOldEmailOtpVerify(false);
    setEmailUpdate(emailModalInitialValues);
  };

  return (
    <div>
      <VzPageContainer title="Profile Setting">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Profile Setting</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ float: "left" }}>
            <Formik
              enableReinitialize
              initialValues={currentEntity}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autoComplete="off">
                  <Container>
                    <Row>
                      <Col md={7}>
                        <Row className="align-items-center">
                          <Col xs={4} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Full Name</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="fullName"
                                handleOnChange={(e) =>
                                  (currentEntity.fullName = e)
                                }
                                value={currentEntity.fullName}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={4} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Distributor</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="distributor"
                                readOnly={true}
                                value={currentEntity.distributor}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={4} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Dist Center</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="distCenter"
                                readOnly={true}
                                value={currentEntity.distCenter}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={4} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Email</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="email"
                                readOnly={true}
                                value={currentEntity.email}
                              />
                            </div>
                          </Col>
                          <Col xs={2}>
                            <div onClick={ShowEmailModal}>
                              <i
                                class="fas fa-pencil-alt fa-lg"
                                style={{ marginBottom: "20px" }}
                              ></i>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={4} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Phone No.</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="phoneNo"
                                readOnly={true}
                                value={currentEntity.phoneNo}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={4} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">CNIC</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="cnic"
                                readOnly={true}
                                value={currentEntity.cnic}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={5}>
                        <div className="form-group ">
                          {!ImageURL && (
                            <>
                              <div>Select Image</div>
                              <input
                                type="file"
                                name="url"
                                accept="image/*"
                                onChange={async (event) =>
                                  await saveImage(event)
                                }
                              />
                            </>
                          )}
                          <div>
                            {ImageURL && (
                              <>
                                <div>
                                  <img
                                    style={{ border: "1px solid #ccc" }}
                                    className="mt-2"
                                    alt="not fount"
                                    width={"225px"}
                                    height={"200px"}
                                    src={ImageURL}
                                  />
                                </div>
                                <div className="mt-3">
                                  <Button
                                    onClick={removeImage}
                                    className="btn-sm ml-5"
                                    style={{ backgroundColor: "#ea5f2d" }}
                                  >
                                    Remove
                                  </Button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row style={{ float: "right" }}>
                      <Col md={12}>
                        <Button
                          className="btn btn-default"
                          style={{ width: "100px", marginRight: "5px" }}
                          onClick={handleBackBtn}
                        >
                          Back
                        </Button>
                        <Button
                          type="submit"
                          className="btn btn-primary"
                          style={{ width: "100px" }}
                          disabled={isSubmitting}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
        {/* Form Start*/}
        <row>
          <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Formik
              enableReinitialize
              initialValues={emailUpdate}
              validationSchema={validationSchemaEmailModal}
              onSubmit={handleSubmitChangeEmailModal}
            >
              {(formik) => (
                <Form autoComplete="off">
                  <Modal.Header closeButton>
                    <Modal.Title
                      id="contained-modal-title-vcenter"
                      style={{ color: "#ea5f2d" }}
                    >
                      Change Email
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <Row className="align-items-center">
                            <Col
                              xs={2}
                              className="d-flex align-items-center"
                              style={{ justifyContent: "end" }}
                            >
                              <div className="form-group">
                                <label className="mb-0">Old Email</label>
                              </div>
                            </Col>
                            <Col xs={2}></Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="text"
                                  name="oldEmail"
                                  readOnly="true"
                                  handleOnChange={(e) =>
                                    (emailUpdate.oldEmail = e)
                                  }
                                  value={emailUpdate.oldEmail}
                                />
                              </div>
                            </Col>
                            <Col xs={2} style={{ marginTop: "-16px" }}>
                              <Button
                                value="Send OTP"
                                className="btn btn-default"
                                onClick={handleSendOtp}
                                disabled={isSubmitting}
                              >
                                Send OTP
                              </Button>
                            </Col>
                          </Row>
                          <Row className="align-items-center">
                            <Col
                              xs={2}
                              className="d-flex align-items-center"
                              style={{ justifyContent: "end" }}
                            >
                              <div className="form-group">
                                <label className="mb-0">OTP</label>
                              </div>
                            </Col>
                            <Col xs={2}></Col>
                            <Col xs={6}>
                              <div
                                className="form-group"
                                style={{ marginBottom: "5px" }}
                              >
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="text"
                                  name="oldEmailOtp"
                                  disabled={isOldEmailOtpVerify}
                                  handleOnChange={(e) =>
                                    (emailUpdate.oldEmailOtp = e)
                                  }
                                  value={emailUpdate.oldEmailOtp}
                                />
                              </div>
                            </Col>
                            <Col xs={2} style={{ marginTop: "-4px" }}>
                              <Button
                                className="btn btn-primary"
                                onClick={handleVerifyOtp}
                                disabled={isOldEmailOtpVerify || isSubmitting}
                                style={{ marginRight: "10px" }}
                              >
                                Verify OTP
                              </Button>
                              {isOldEmailOtpVerify &&
                              emailUpdate.oldEmailOtp.length > 1 ? (
                                <i
                                  class="fas fa-check fa-lg"
                                  style={{ color: "#ea5f2d" }}
                                ></i>
                              ) : !isOldEmailOtpVerify &&
                                emailUpdate.oldEmailOtp.length > 1 ? (
                                <i
                                  class="fas fa-times fa-lg"
                                  style={{ color: "#000" }}
                                ></i>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                          <Row className="align-items-center">
                            <Col xs={4}></Col>
                            <Col xs={6}>
                              <span
                                id="resendOtp"
                                style={hoverStyle}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={
                                  !isSubmitting ? handleSendOtp : undefined
                                }
                              >
                                Resend OTP
                              </span>
                            </Col>
                          </Row>
                          <Row className="align-items-center">
                            <Col
                              xs={2}
                              className="d-flex align-items-center"
                              style={{ justifyContent: "end" }}
                            >
                              <div className="form-group">
                                <label className="mb-0">New Email</label>
                              </div>
                            </Col>
                            <Col xs={2}></Col>
                            <Col xs={6}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="text"
                                  name="newEmail"
                                  disabled={!isOldEmailOtpVerify}
                                  handleOnChange={(e) =>
                                    (emailUpdate.newEmail = e)
                                  }
                                  value={emailUpdate.newEmail}
                                />
                              </div>
                              <div>
                                <p style={{ fontSize: "16px", color: "blue" }}>
                                  <span style={{ fontWeight: "bolder" }}>
                                    Note:
                                  </span>{" "}
                                  Please check your inbox to verify your new
                                  email address after saving.
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Container>
                  </Modal.Body>
                  <Modal.Footer>
                    <input
                      id="btnSaveEmail"
                      type="submit"
                      className="btn btn-primary"
                      value="Save"
                      disabled={
                        isSubmitting ||
                        (!isOldEmailOtpVerify &&
                          emailUpdate.newEmail.length > 1)
                      }
                    />
                    <Button
                      className="btn btn-default"
                      onClick={handleCloseChangeEmailModal}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          </Modal>
        </row>
        {/* Form End*/}
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    Profile: state.Profile ? state.Profile : {},
  };
};

export default connect(mapStateToProps, {
  getProfileSetting,
  updateProfileSetting,
  sendOtpToVerifyEmail,
  saveNewEmail,
})(ProfileSetting);
